import { Bell } from "lucide-react";
import { useNotificationStore } from "@/contexts/NotificationsProvider";
import NotificationBellReady from "@/components/navbar/notifications/NotificationBellReady";

function NotificationBell() {
  const { status, activeStoreId } = useNotificationStore();

  if (status === "disabled") return null;

  if (status !== "ready" || !activeStoreId) {
    return (
      <button
        type="button"
        aria-label="Notifications"
        disabled
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-text-muted"
      >
        <Bell size={18} />
      </button>
    );
  }

  return <NotificationBellReady />;
}

export default NotificationBell;
